import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { config } from '../config';

function Profile() {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const raw = sessionStorage.getItem('sessionData');
    if (!raw) {
      navigate('/');
      return;
    }

    const sessionData = JSON.parse(raw);

    axios.post(`${config.getBackendUrl()}/get_user`, {
      email: sessionData.username
    })
      .then(res => setUserInfo(res.data))
      .catch(() => setError('Could not load profile.'));
  }, [navigate]);

  return (
    <div className="center-container">
      <div className="card">
        <h1>Profile</h1>
        {error && <p className="field-error">{error}</p>}
        {userInfo && (
          <div style={{ marginTop: '16px', textAlign: 'left' }}>
            <p><strong>First name:</strong> {userInfo.first_name}</p>
            <p style={{ marginTop: '8px' }}><strong>Last name:</strong> {userInfo.last_name}</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default Profile;
